<template>
  <div class="form-group">
    <label :style="template.style.surveyBgColor ? {color: template.style.firstColor } : {color: black}" class="title-bold" for="nome">
      {{ questionText }} <span v-if="mandatoryQuestion === false">(Opcional)</span>
    </label>
    <input
      type="text"
      class="form-control"
      :style="template.style.surveyBgColor ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white', color: 'black'}"
      :id="'cpf'"
      :placeholder="getPlaceHolder"
      :inputmode="documentInputMode"
      v-model="qtAnwser"
      v-on:keyup.enter="enterKey"
      v-on:keyup="allKeys"
      v-mask="inputMask"
    />
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import {
  getDocumentRule,
  sanitizeDocumentValue
} from "./documentRules";
export default {
  name: "Survey-Cpf-Text",
  data: () => ({
    qtAnwser: "",
    dataOk: false,
  }),
  directives: {
    mask,
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      },
    },
  },
  computed: {
    getPlaceHolder() {
      if (this.documentRule) return this.documentRule.placeholder;
      if (this.placeHolder) return this.placeHolder;
      return "XXX.XXX.XXX-XX";
    },
    documentRule() {
      return getDocumentRule(this.questionId);
    },
    inputMask() {
      return this.documentRule ? this.documentRule.mask : "###.###.###-##";
    },
    documentInputMode() {
      return this.documentRule && this.documentRule.mask.includes("X") ? null : "numeric";
    },
    template() {
      return this.$store.state.template;
    }
  },
  mounted: function() {
    this.qtAnwser = this.$store.getters.answerValue(this.questionId);

    this.focusInput();
  },
  watch: {
    qtAnwser() {
      this.allKeys();
    },
  },
  created() {},
  updated() {
    this.focusInput();
  },
  props: {
    questionText: { type: String },
    questionId: { type: Number },
    placeHolder: { type: String },
    mandatoryQuestion: { type: Boolean }
  },
  methods: {
    focusInput() {
      this.$refs.fc.$el.focus();
    },
    normalizeAnswer(value) {
      return sanitizeDocumentValue(value, this.questionId);
    },
    allKeys() {
      this.qtAnwser = this.normalizeAnswer(this.qtAnwser);
      this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
    },
    enterKey() {
        this.qtAnwser = this.normalizeAnswer(this.qtAnwser);
        this.$emit("QuestionAnwered", this.qtAnwser, this.questionId);
    },
  },
};
</script>

<style scoped>
.title-bold{
  font-family:'OxaniumBold';
}</style>
